import { closeButtonOverrideStyles, drawerOverridesStyles, StyledActionButton } from '@shared/components/InviteAdminDialog/components/Shared.styles';
import { ResponsiveDialog } from '@shared/components/ResponsiveDialog';
import { useTranslation } from '@shared/core';
import { CloseButton, Flex, SpacingStack, TextV2 } from '@withjoy/joykit';
import React from 'react';

type ConfirmationDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
};

export const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { tq } = useTranslation('faqCustomComponent');
  const { isOpen, onClose, onConfirm, title, message, confirmText = tq`confirm`, cancelText = tq`cancel` } = props;

  return (
    <ResponsiveDialog
      isOpen={isOpen}
      onClose={onClose}
      hasCloseButton={false}
      hideDivider={true}
      removeBodyPadding={true}
      dialogOverrides={{
        Content: { props: { width: ['100%', '480px'] } },
        Body: { props: { paddingX: 8, paddingY: 8 } },
      }}
      drawerOverrides={drawerOverridesStyles}
    >
      <CloseButton
        overrides={closeButtonOverrideStyles}
        onClick={onClose}
        aria-label={'close dialog'}
      />
      <SpacingStack
        textAlign="center"
        spacing={6}
      >
        <TextV2 typographyVariant={['hed3', 'hed6']}>{title}</TextV2>
        <TextV2 typographyVariant="body2">{message}</TextV2>
      </SpacingStack>
      <Flex
        flexDirection="column"
        width="100%"
        gap={5}
        marginTop={8}
      >
        <StyledActionButton
          intent="destructive"
          onClick={onConfirm}
        >
          {confirmText || tq`Confirm`}
        </StyledActionButton>
        <StyledActionButton
          color="mono14"
          variant="ghost"
          backgroundColor="transparent"
          onClick={onClose}
        >
          {cancelText || tq`Cancel`}
        </StyledActionButton>
      </Flex>
    </ResponsiveDialog>
  );
};
